import { render, staticRenderFns } from "./ContentCarousel.vue?vue&type=template&id=b8c371d4"
import script from "./ContentCarousel.vue?vue&type=script&lang=ts"
export * from "./ContentCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports